// GENERATED by scripts/gen-web-routes.mjs — regenerate after frontend/app/ changes.
import { createFileRoute } from "@tanstack/react-router"
import Page from "@/app/inspector/page"
import { usePageHead } from "../../compat/head"

export const Route = createFileRoute("/inspector/")({
  component: PageComponent,

})

function PageComponent() {
  usePageHead({ title: "Inspector" })
  return <Page />
}
